export default __webpack_public_path__ + "static/media/main-hisky-login.149b98d8.svg";